<template>
  <div class="customer-current-info loader-container">
    <h2>Current Info</h2>
    <div class="table-wrapper loader-container">
      <vue-good-table
        :columns="[
          {
            label: 'Name',
            field: 'infoName'
          },
          {
            label: 'Value',
            field: 'infoValue'
          }
        ]"
        :rows="customerCurrentInfo"
      ></vue-good-table>
      <Loader :loading="loadingCustomerCurrentInfo" />
    </div>
  </div>
</template>

<script>
import service from "@/services/service.js";
import Loader from "@/components/Loader.vue";
import { VueGoodTable } from "vue-good-table";
export default {
  components: { Loader, VueGoodTable },
  props: {
    customerId: { type: String, default: null }
  },
  data() {
    return {
      customerCurrentInfo: [],
      loadingCustomerCurrentInfo: false
    };
  },
  created() {
    this.getCustomerCurrentInfo();
  },
  methods: {
    getCustomerCurrentInfo() {
      var self = this;
      self.loadingCustomerComponents = true;
      service
        .getCustomerCurrentInfo(self.customerId)
        .then(response => {
          self.customerCurrentInfo = response.data;
          self.loadingCustomerCurrentInfo = false;
        })
        .catch(() => {
          self.loadingCustomerCurrentInfo = false;
        });
    }
  }
};
</script>
